<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : !disabled ? '修改' : '查看'"
    :close-on-click-modal="false"
    :visible.sync="visible"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="80px"
    >
      <el-form-item label="补助类型名称" prop="name">
        <el-input
          v-model="dataForm.name"
          :disabled="disabled"
          placeholder="补助类型名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="删除状态 0：已删除 1：正常" prop="isDelete">
        <el-input
          v-model="dataForm.isDelete"
          :disabled="disabled"
          placeholder="删除状态 0：已删除 1：正常"
        ></el-input>
      </el-form-item>
      <el-form-item label="创建时间 " prop="createdAt">
        <el-input
          v-model="dataForm.createdAt"
          :disabled="disabled"
          placeholder="创建时间 "
        ></el-input>
      </el-form-item>
      <el-form-item label="更新时间" prop="updatedAt">
        <el-input
          v-model="dataForm.updatedAt"
          :disabled="disabled"
          placeholder="更新时间"
        ></el-input>
      </el-form-item>
      <el-form-item label="创建者 " prop="createdName">
        <el-input
          v-model="dataForm.createdName"
          :disabled="disabled"
          placeholder="创建者 "
        ></el-input>
      </el-form-item>
      <el-form-item label="修改者" prop="opName">
        <el-input
          v-model="dataForm.opName"
          :disabled="disabled"
          placeholder="修改者"
        ></el-input>
      </el-form-item>
      <el-form-item label="电话号码" prop="phone">
        <el-input
          v-model="dataForm.phone"
          :disabled="disabled"
          placeholder="电话号码"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!disabled" type="primary" @click="dataFormSubmit()"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      disabled: false,
      visible: false,
      dataForm: {
        id: 0,
        name: '',
        isDelete: '',
        createdAt: '',
        updatedAt: '',
        createdName: '',
        opName: '',
        phone: '',
      },
      dataRule: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
      },
    };
  },
  methods: {
    init(id, disabled) {
      this.disabled = disabled;
      this.dataForm.id = id || '';
      this.visible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields();
        if (this.dataForm.id) {
          this.$http({
            url: `/tc/subsidy/info/${this.dataForm.id}`,
            method: 'get',
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.dataForm = data.subsidy;
            }
          });
        }
      });
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: `/tc/subsidy/${!this.dataForm.id ? 'save' : 'update'}`,
            method: 'post',
            data: this.dataForm,
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
              });
              this.visible = false;
              this.$emit('refreshDataList');
            }
          });
        }
      });
    },
  },
};
</script>
